import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../../../context/AuthContext';
import Swal from 'sweetalert2';
import QuestionContents from './UI/QuestionContents';
import ReactPlayer from 'react-player';
import ReactDOM from 'react-dom';
import { useParams } from "react-router-dom";
import axios from "axios";

import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './matchcss.css';

const RealMatch = (props) => {
    const [msg, setMsg] = useState([]);
    const { user } = useAuth();
    const [question, setQuestion] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [questionText, setQuestionText] = useState([]);
    const [userAnswers, setUserAnswers] = useState([]);
    const [leftItems, setLeftItems] = useState([]);
    const [rightItems, setRightItems] = useState([]);
    const [blurredIds, setBlurredIds] = useState([]);
    const [lastDrop, setLastDrop] = useState(null);
    const [subjectName, setSubjectName] = useState("");
    const params = useParams();
    const ATTEMPT_KEY = `choice_attempt_${props.questionNumber}`;

    const getSubject = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";
            await axios({
                method: 'GET',
                url: url,
                headers: headerss,
                params: {
                    courseId: params['courseid'],
                }
            }).then(res => {
                if (res.data['success']) {
                    setSubjectName(
                        res.data['data']['subjects'][params['subjectid'] - 1]['subjectName'] +
                        " - " +
                        res.data['data']['subjects'][params['subjectid'] - 1]['subjectDesc']
                    );
                }
            });
        } catch (err) {
            console.log();
        }
    };

    const Request = async (userAnswer) => {
        let ans = "";
        if (userAnswer) {
            ans = props.data.answer;
        } else {
            ans = "hatali cevap";
        }

        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = "https://api.heryerdeingilizce.com/api/user/Content/Answer";

            await axios({
                method: 'POST',
                url: url,
                params: {
                    courseId: Number(params.courseid),
                    question: Number(props.data.id),
                    answer: String(ans)
                },
                headers: headerss
            }).then(res => {
                localStorage.removeItem(ATTEMPT_KEY);

                if (res.data['success']) {
                    props.playSuccessSound?.();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href =
                            "/user/course/question/" +
                            params['courseid'] +
                            "/" +
                            params['subjectid'] +
                            "/" +
                            newurl;
                    });
                } else {
                    if (res.data['alertType'] === "question") {
                        props.playErrorSound?.();
                        Swal.fire({
                            title: "Hatalı cevap",
                            text: props.data.notfyText,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href =
                                "/user/course/question/" +
                                params['courseid'] +
                                "/" +
                                params['subjectid'] +
                                "/" +
                                newurl;
                        });
                    } else {
                        let errorMsg = res['data']['message'];
                        props.playErrorSound?.();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href =
                                "/user/course/question/" +
                                params['courseid'] +
                                "/" +
                                params['subjectid'] +
                                "/" +
                                newurl;
                        });
                    }
                }
            });
        } catch (err) {
            alert(err.message);
            setMsg(err.message);
        }
    };

    const renderContent = (item) => {
        if (item.service && item.service.trim() !== "") {
            return <div className="realmatch-text-content"><strong>{item.service}</strong></div>;
        }

        if (item.photo) {
            return <img src={item.photo} alt="" className="realmatch-media" />;
        }

        if (item.photourl) {
            return <img src={item.photourl} alt="" className="realmatch-media" />;
        }

        if (item.sound) {
            return (
                <div>
                    <style>{`
                        .rhap_volume-controls,
                        .rhap_additional-controls,
                        .rhap_repeat-button,
                        .rhap_skip-button,
                        .rhap_rewind-button,
                        .rhap_forward-button,
                        .rhap_volume-button,
                        .rhap_time {
                            display: none !important;
                        }

                        .custom-player {
                            width: 60px !important;
                            height: 60px !important;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            border: none !important;
                            box-shadow: none !important;
                        }

                        .custom-player .rhap_play-pause-button {
                            font-size: 40px !important;
                            color: blue !important;
                        }

                        .custom-player .rhap_progress-section {
                            display: none !important;
                        }

                        @media (max-width: 768px) {
                            .custom-player {
                                width: 48px !important;
                                height: 48px !important;
                            }

                            .custom-player .rhap_play-pause-button {
                                font-size: 30px !important;
                            }
                        }
                    `}</style>
                    <AudioPlayer src={item.sound} className="custom-player" />
                </div>
            );
        }

        if (item.soundurl) {
            return (
                <div>
                    <style>{`
                        .rhap_volume-controls,
                        .rhap_additional-controls,
                        .rhap_repeat-button,
                        .rhap_skip-button,
                        .rhap_rewind-button,
                        .rhap_forward-button,
                        .rhap_volume-button,
                        .rhap_time {
                            display: none !important;
                        }

                        .custom-player {
                            width: 60px !important;
                            height: 60px !important;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            border: none !important;
                            box-shadow: none !important;
                        }

                        .custom-player .rhap_play-pause-button {
                            font-size: 40px !important;
                            color: blue !important;
                        }

                        .custom-player .rhap_progress-section {
                            display: none !important;
                        }

                        @media (max-width: 768px) {
                            .custom-player {
                                width: 48px !important;
                                height: 48px !important;
                            }

                            .custom-player .rhap_play-pause-button {
                                font-size: 30px !important;
                            }
                        }
                    `}</style>
                    <AudioPlayer src={item.soundurl} className="custom-player" />
                </div>
            );
        }

        if (item.video) {
            return (
                <div className="realmatch-video-wrap">
                    <ReactPlayer url={item.video} controls={true} width="100%" height="100%" />
                </div>
            );
        }

        if (item.videourl) {
            return (
                <div className="realmatch-video-wrap">
                    <ReactPlayer url={item.videourl} controls={true} width="100%" height="100%" />
                </div>
            );
        }

        return null;
    };

    const undoLastDrop = () => {
        if (!lastDrop) return;

        setUserAnswers(prev =>
            prev.filter(ans => !(ans.target === lastDrop.target && ans.source === lastDrop.source))
        );

        setBlurredIds(prev => prev.filter(id => id !== lastDrop.source));

        if (lastDrop.element && lastDrop.element.parentNode) {
            lastDrop.element.parentNode.removeChild(lastDrop.element);
        }
        if (lastDrop.hr && lastDrop.hr.parentNode) {
            lastDrop.hr.parentNode.removeChild(lastDrop.hr);
        }

        setLastDrop(null);
    };

    const handleDrop = (e) => {
        e.preventDefault();

        const draggedId = e.dataTransfer.getData("text/plain");
        const draggedEl = document.getElementById(draggedId);
        const dropTarget = e.target.closest(".drop-zone");

        if (!draggedEl || !dropTarget) return;

        const targetId = parseInt(dropTarget.getAttribute("data-id"), 10);

        const alreadyFilled = userAnswers.some(ans => ans.target === targetId);
        if (alreadyFilled) {
            props.playErrorSound?.();
            Swal.fire({
                icon: "warning",
                title: "Bu alana zaten eşleştirme yapıldı",
                text: "Önce mevcut eşleşmeyi geri alın.",
                confirmButtonText: "Tamam"
            });
            return;
        }

        const sourceItem = rightItems.find(i => (i.id + 's') === draggedId);
        if (!sourceItem) return;

        const hr = document.createElement("hr");
        hr.style.width = "80%";
        hr.style.borderTop = "1px dashed #aaa";
        hr.style.margin = "8px 0";

        const cloned = document.createElement("div");
        cloned.classList.add("dropped-item");
        cloned.setAttribute("draggable", false);
        cloned.setAttribute("data-origin-id", draggedId);
        cloned.style.width = "100%";
        cloned.style.minHeight = "50px";
        cloned.style.height = "auto";
        cloned.style.display = "flex";
        cloned.style.alignItems = "center";
        cloned.style.justifyContent = "center";
        cloned.style.overflow = "hidden";
        cloned.style.padding = "5px";

        const mountPoint = document.createElement("div");
        cloned.appendChild(mountPoint);

        if (dropTarget.children.length > 0) {
            dropTarget.appendChild(hr);
        }
        dropTarget.appendChild(cloned);

        setTimeout(() => {
            ReactDOM.render(renderContent(sourceItem), mountPoint);
        }, 0);

        setUserAnswers(prev => {
            const updated = [...prev, { target: targetId, source: draggedId }];
            setLastDrop({ target: targetId, source: draggedId, element: cloned, hr });
            return updated;
        });

        setBlurredIds(prev => [...new Set([...prev, draggedId])]);
    };

    const allowDrop = (e) => e.preventDefault();

    const handleSubmit = (e) => {
        e.preventDefault();
        const attempt = parseInt(localStorage.getItem(ATTEMPT_KEY) || "0", 10);

        if (userAnswers.length !== leftItems.length) {
            Swal.fire({
                icon: "warning",
                title: "Eksik Eşleştirme",
                text: "Lütfen tüm eşleştirmeleri tamamlayın"
            });
            return;
        }

        const isCorrect = userAnswers.every(ans => {
            const sourceId = parseInt(ans.source.replace("s", ""), 10);
            return ans.target === sourceId;
        });

        if (attempt === 0 || attempt === 1) {
            if (isCorrect) {
                Request(true);
            } else {
                localStorage.setItem(ATTEMPT_KEY, String(attempt + 1));
                props.playErrorSound?.();
                Swal.fire({
                    title: attempt === 0 ? "Tekrar Deneyiniz!" : "Son bir kez deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }

        if (isCorrect) {
            Request(true);
        } else {
            Request(false);
        }
    };

    const handleDragStart = (e, id) => {
        e.dataTransfer.setData("text/plain", id);
    };

    const renewPage = async (e) => {
        e.preventDefault();
        window.location.reload();
    };

    const shuffleArray = (array) => {
        return [...array].sort(() => Math.random() - 0.5);
    };

    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }
    }, [ATTEMPT_KEY]);

    useEffect(() => {
        getSubject();
        const questionn = JSON.parse(props.data.contentStr);
        const questionTitlee = questionn['text'].split('__')[0];
        const questionTextt = questionn['text'].split('__')[1];
        const answerss = JSON.parse(props.data.detail);

        setQuestion(questionn);
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
        setAnswers(answerss);

        const shuffledLeft = shuffleArray(answerss.filter(a => a.type === 0));
        const shuffledRight = shuffleArray(answerss.filter(a => a.type === 1));
        setLeftItems(shuffledLeft);
        setRightItems(shuffledRight);
    }, []);

    return (
        <div>
            <span style={{ color: "black" }}>
                <b><i>{subjectName}</i></b>
            </span>
            <br />
            <b>Match Sorusu</b>
            <br />

            <div style={{ alignItems: "center", textAlign: "center", justifyContent: "center" }}>
                <QuestionContents question={question} />
                {!(question?.type === "sound" || question?.type === "video" || question?.type === "image" || question?.type === "image_sound") && (
                    <>
                        <br />
                        <br />
                    </>
                )}
                <b style={{ fontSize: "18px", fontFamily: 'calibri', color: "SteelBlue" }}>
                    {questionTitle}
                </b>
                <br />
                <b className="realmatch-question-text">
                    {questionText}
                </b>
                <br />
            </div>

            <div className="d-flex justify-content-center realmatch-wrapper" style={{ fontSize: 20, textAlign: "center" }}>
                <form onSubmit={handleSubmit} className="realmatch-form">

                    <div className="realmatch-row">
                        {leftItems.map((dt) => {
                            const isFilled = userAnswers.some(ans => ans.target === dt.id);

                            return (
                                <div key={dt.id} className="realmatch-col">
                                    <div
                                        data-id={dt.id}
                                        className="drop-zone realmatch-card"
                                        onDrop={handleDrop}
                                        onDragOver={allowDrop}
                                        style={{
                                            border: isFilled ? '2px solid #28a745' : '2px groove #7ac1f7ff',
                                            backgroundColor: isFilled ? '#f3fff5' : 'white',
                                            opacity: isFilled ? 0.92 : 1,
                                        }}
                                    >
                                        {renderContent(dt)}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <hr />

                    <div className="realmatch-row">
                        {rightItems.map((dt, index) => (
                            <div key={dt.id} className="realmatch-col">
                                <div
                                    id={rightItems[index].id + 's'}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, rightItems[index].id + 's')}
                                    className="realmatch-card"
                                    style={{
                                        filter: blurredIds.includes(rightItems[index].id + 's') ? 'blur(3px)' : 'none'
                                    }}
                                >
                                    {renderContent(rightItems[index])}
                                </div>
                            </div>
                        ))}
                    </div>

                    <br /><br />

                    <div className="realmatch-actions">
                        <button type="button" className="undo-btn" onClick={undoLastDrop}>
                            Son İşlemi Geri Al
                        </button>
                        <button type="button" className="renew-btn" onClick={renewPage}>
                            Yeniden Oluştur
                        </button>
                        <button type="submit" className="save-btn">
                            Cevapları Gönder
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RealMatch;